import { type Dispatch, type SetStateAction, createContext } from "react";

import { API } from "../api/util";

export interface ApisContext {
    step: string;
    setStep?: Dispatch<SetStateAction<string>>;
    agreement: boolean;
    setAgreement: Dispatch<SetStateAction<boolean>>;
}

const defaultApisContext: ApisContext = {
    step: API,
    agreement: false,
    setAgreement: () => {
        // no-op
    },
};

export const ApisContext = createContext<ApisContext>(defaultApisContext);
